// ⚠️⚠️⚠️⚠️ DO NOT EDIT ⚠️⚠️⚠️⚠️
// This file was automatically generated, run yarn gen:gql to update it
/* eslint-disable */

import type * as Types from '../../../../../schema/public';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type MyBalanceChangedSubscriptionVariables = Types.Exact<{ [key: string]: never; }>;


export type MyBalanceChangedSubscription = { __typename?: 'Subscription', bankingMyBalanceChanged?: { __typename?: 'BankingMyBalanceChangedSubscriptionPayload', clientSubscriptionId?: string, changedBalance?: { __typename?: 'BankingBalance', id: string, currency?: string, totalBalance?: number, totalBonusBalance?: number, realBalance?: number, cashierBalance?: number } } };


export const MyBalanceChangedSubscriptionDocument = /*#__PURE__*/ gql`
    subscription MyBalanceChangedSubscription {
  bankingMyBalanceChanged(input: {}) {
    changedBalance {
      id
      currency
      totalBalance
      totalBonusBalance
      realBalance
      cashierBalance
    }
    clientSubscriptionId
  }
}
    `;
export function useMyBalanceChangedSubscription(baseOptions?: Apollo.SubscriptionHookOptions<MyBalanceChangedSubscription, MyBalanceChangedSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<MyBalanceChangedSubscription, MyBalanceChangedSubscriptionVariables>(MyBalanceChangedSubscriptionDocument, options);
      }
export type MyBalanceChangedSubscriptionHookResult = ReturnType<typeof useMyBalanceChangedSubscription>;
export type MyBalanceChangedSubscriptionSubscriptionResult = Apollo.SubscriptionResult<MyBalanceChangedSubscription>;